import { HiddenInputField, NumberRange, ParentInputType } from "../../../shared/components/web-form/form-field/hidden-input";
import { TextInputField, TextInputType } from "../../../shared/components/web-form/form-field/text-input";
import { DateInputField, DateInputOptions, DropdownInputField, DropdownInputOptions, FileUploadInputField, FileUploadInputOptions, FormSection, NumberInputField, NumberInputOptions, TextInputOptions, YesNoInputField, YesNoInputOptions } from "../../../shared/components/web-form/web-form.objects";

export class CabSurveyForm {
    constructor() { }

    static getFormSections(isNew: boolean = false, isEdit: boolean = false): FormSection[] {
        let textOptions = new TextInputOptions(TextInputType.Any, -99, -99, false, 4);

        let formFields = [];
        if (isNew || isEdit) {
            formFields = [
                new DropdownInputField("CabHubConnectionId", "cab-survey-connection-id", "Connection", "", true, new DropdownInputOptions("pl-connection", false, true, true, isEdit)),
                new DropdownInputField("ReportingMonth", "cab-survey-reporting-month", "Reporting Month", "", true, new DropdownInputOptions("pl-month", false, true, false, isEdit)),
                new DropdownInputField("ReportingYear", "cab-survey-reporting-year", "Reporting Year", "", true, new DropdownInputOptions("pl-year", false, true, false, isEdit)),
            ];
        }

        formFields.push(
            new YesNoInputField("MetThisMonth", "cab-survey-met-this-month", "Did you meet with your Hub this month?", "", true),
            new HiddenInputField({
                hiddenInput: new NumberInputField("HoursWorked", "cab-survey-hours-worked", "How many hours did you work with your Hub this month?", "", true, new NumberInputOptions(false, 0)),
                isNested: false,
                parentInputId: "cab-survey-met-this-month",
                parentInputType: ParentInputType.YesNo,
                showParentValueArray: ["1"]
            }),
            new HiddenInputField({
                hiddenInput: new TextInputField("NotMetExplanation", "cab-survey-not-met-explanation", "Why not?", "", true, textOptions),
                isNested: false,
                parentInputId: "cab-survey-met-this-month",
                parentInputType: ParentInputType.YesNo,
                showParentValueArray: ["0"]
            }),
            new HiddenInputField({
                hiddenInput: new NumberInputField("AdditionalHoursCompensationRate", "cab-survey-compensation-rate", "In total, how much were you compensated for the additional hours worked (any number of hours >2 hours)?", "", true, new NumberInputOptions(false, 0, undefined, "$")),
                isNested: false,
                parentInputId: "cab-survey-hours-worked",
                parentInputType: ParentInputType.Number,
                showInRange: new NumberRange(2.01, undefined)
            }),
            new DropdownInputField("AnticipatedHoursNextMonthId", "cab-survey-anticipated-hours", "Do you anticipate working with your Hub for more than two hours next month?", "", true, new DropdownInputOptions("YesNoNotSure", false, false, false)),
            new DropdownInputField("ConsultationTypeIds", "cab-survey-consultation-types", "What type of consultation did you provide?", "", true, new DropdownInputOptions("CabConsultationType", true, true, false)),
            new HiddenInputField({
                hiddenInput: new TextInputField("OtherConsultationType", "cab-survey-other-consultation-type", "Please explain.", "", true, textOptions),
                isNested: false,
                parentInputId: "cab-survey-consultation-types",
                parentInputType: ParentInputType.DropdownMulti,
                showParentValueArray: ["5"]
            }),
            new TextInputField("WorkDescription", "cab-survey-work-description", "Please describe what you worked on this month in 2–3 sentences.", "", true, textOptions),
            new DropdownInputField("SatisfactionRatingId", "cab-survey-satisfaction-rating", "How satisfied were you with your Hub partnership this month?", "", true, new DropdownInputOptions("SatisfactionRating", false, false, false)),
            new TextInputField("SatisfactionExplanation", "cab-survey-satisfaction-explanation", "Can you tell us more about your answer to the previous question?", "", false, textOptions),
            new YesNoInputField("SupportRequested", "cab-survey-support-requested", "Would you like to request support from the INTERACT team?", "", true, new YesNoInputOptions()),
            new HiddenInputField({
                hiddenInput: new TextInputField("SupportRequestExplanation", "cab-survey-support-explanation", "Please explain.", "", true, textOptions),
                isNested: false,
                parentInputId: "cab-survey-support-requested",
                parentInputType: ParentInputType.YesNo,
                showParentValueArray: ["1"]
            }),
            new DropdownInputField("TrainingNeededId", "cab-survey-training-needed", "Based on what you’ve been working on, is there training that would be useful to support your future work?", "", true, new DropdownInputOptions("YesNoNotSure", false, false, true)),
            new HiddenInputField({
                hiddenInput: new TextInputField("TrainingDescription", "cab-survey-training-description", "What kind of training?", "", true, textOptions),
                parentInputId: "cab-survey-training-needed",
                isNested: false,
                parentInputType: ParentInputType.DropdownSingle,
                showParentValueArray: ["1"]
            })
        );

        let section: FormSection = new FormSection({
            sectionId: "cab-survey-form",
            displayName: "",
            formFields: formFields
        });

        let formSections = [section];

        return formSections;
    }
}

export class HubSurveyForm {
    constructor() { }

    static getFormSections(cabMemberName: string, isNew: boolean = false, isEdit: boolean = false): FormSection[] {
        let textOptions = new TextInputOptions(TextInputType.Any, -99, -99, false, 4);

        let formFields = [];
        if (isNew || isEdit) {
            formFields = [
                new DropdownInputField("CabHubConnectionId", "cab-survey-connection-id", "Connection", "", true, new DropdownInputOptions("pl-connection", false, true, true, isEdit)),
                new DropdownInputField("ReportingMonth", "cab-survey-reporting-month", "Reporting Month", "", true, new DropdownInputOptions("pl-month", false, true, false, isEdit)),
                new DropdownInputField("ReportingYear", "cab-survey-reporting-year", "Reporting Year", "", true, new DropdownInputOptions("pl-year", false, true, false, isEdit)),
            ];
        }

        formFields.push(
            new YesNoInputField("MetThisMonth", "hub-survey-met-this-month", `Did your team meet with ${cabMemberName} this month?`, "", true, new YesNoInputOptions()),
            new HiddenInputField({
                hiddenInput: new NumberInputField("HoursWorked", "hub-survey-hours-worked", `How many hours of consultation did ${cabMemberName} provide this month?`, "", true, new NumberInputOptions(false, 0)),
                isNested: false,
                parentInputId: "hub-survey-met-this-month",
                parentInputType: ParentInputType.YesNo,
                showParentValueArray: ["1"]
            }),
            new HiddenInputField({
                hiddenInput: new TextInputField("NotMetExplanation", "hub-survey-not-met-explanation", "Why not?", "", true, textOptions),
                isNested: false,
                parentInputId: "hub-survey-met-this-month",
                parentInputType: ParentInputType.YesNo,
                showParentValueArray: ["0"]
            }),
            new HiddenInputField({
                hiddenInput: new NumberInputField("AdditionalHoursCompensationRate", "hub-survey-compensation-rate", "In total, how much were they compensated for the additional hours worked (any number of hours >2 hours)?", "", true, new NumberInputOptions(false, 0, undefined, "$")),
                isNested: false,
                parentInputId: "hub-survey-hours-worked",
                parentInputType: ParentInputType.Number,
                showInRange: new NumberRange(2.01, undefined)
            }),
            new DropdownInputField("AnticipatedHoursNextMonthId", "hub-survey-anticipated-hours", `Do you anticipate working with ${cabMemberName} for more than two hours next month?`, "", true, new DropdownInputOptions("YesNoNotSure", false, false, false)),
            new DropdownInputField("ConsultationTypeIds", "hub-survey-consultation-types", `What type of consultation did ${cabMemberName} provide?`, "", true, new DropdownInputOptions("HubConsultationType", true, true, false)),
            new HiddenInputField({
                hiddenInput: new TextInputField("OtherConsultationType", "hub-survey-other-consultation-type", "Please explain.", "", true, textOptions),
                isNested: false,
                parentInputId: "hub-survey-consultation-types",
                parentInputType: ParentInputType.DropdownMulti,
                showParentValueArray: ["5"]
            }),
            new TextInputField("WorkDescription", "hub-survey-work-description", `Please describe in 2–3 sentences what ${cabMemberName} worked on this month.`, "", true, textOptions),
            new DropdownInputField("SatisfactionRatingId", "hub-survey-satisfaction-rating", "How satisfied were you with your partnership this month?", "", true, new DropdownInputOptions("SatisfactionRating", false, false, false)),
            new TextInputField("SatisfactionExplanation", "hub-survey-satisfaction-explanation", "Can you tell us more about your answer to the previous question?", "", false, textOptions),
            new YesNoInputField("SupportRequested", "hub-survey-support-requested", "Would you like to request support from the INTERACT team?", "", true, new YesNoInputOptions()),
            new HiddenInputField({
                hiddenInput: new TextInputField("SupportRequestExplanation", "hub-survey-support-explanation", "Please explain.", "", true, textOptions),
                isNested: false,
                parentInputId: "hub-survey-support-requested",
                parentInputType: ParentInputType.YesNo,
                showParentValueArray: ["1"]
            }),
            new DropdownInputField("TrainingNeededId", "hub-survey-training-needed", `Based on your work with ${cabMemberName} so far, is there training for ${cabMemberName} or your team that would be useful to support future work?`, "", true, new DropdownInputOptions("YesNoNotSure", false, false, false)),
            new HiddenInputField({
                hiddenInput: new TextInputField("TrainingDescription", "hub-survey-training-description", "What kind of training?", "", true, textOptions),
                parentInputId: "hub-survey-training-description",
                isNested: false,
                parentInputType: ParentInputType.DropdownSingle,
                showParentValueArray: ["1"]
            })
        );

        let section: FormSection = new FormSection({
            sectionId: "hub-survey-form",
            displayName: "",
            formFields: formFields
        });

        let formSections = [section];

        return formSections;
    }
}

export class CabHubConnectionForm {
    constructor() { }

    static getFormSections(): FormSection[] {
        let textOptions = new TextInputOptions(TextInputType.Any, -99, -99, false, 4);

        let section: FormSection = new FormSection({
            sectionId: "cab-hub-connection-form",
            displayName: "",
            formFields: [
                new DropdownInputField("CabMemberUserId", "cab-hub-cab-member", "CAB Member", "", true, new DropdownInputOptions("pl-cab-member", false, true)),
                new DropdownInputField("HubId", "cab-hub-hub", "Hub", "", true, new DropdownInputOptions("pl-short-hub", false, true)),
                new DropdownInputField("StatusId", "cab-hub-connection-form-status", "Status", "", true, new DropdownInputOptions("pl-connection-status", false, true, false)),
                new DateInputField("StartDate", "cab-hub-start-date", "Start Date", "", true, new DateInputOptions()),
                new DateInputField("EndDate", "cab-hub-end-date", "End Date", "", false, new DateInputOptions()),
                new FileUploadInputField("AgreementUploadId", "cab-hub-agreement-upload", "Agreement / Contract Upload", "", false, new FileUploadInputOptions("cab-hub-uploads", false, true)),
                new TextInputField("AdminNotes", "cab-hub-notes", "Notes", "Add internal notes about the relationship, status, documentation, or follow-up items.", false, textOptions)
            ]
        });

        let formSections = [section];

        return formSections;
    }

    static getEditFormSections(): FormSection[] {
        let textOptions = new TextInputOptions(TextInputType.Any, -99, -99, false, 4);

        let section: FormSection = new FormSection({
            sectionId: "cab-hub-connection-form",
            displayName: "",
            formFields: [
                new DropdownInputField("CabMemberUserId", "cab-hub-cab-member", "CAB Member", "", true, new DropdownInputOptions("pl-cab-member", false, true, true, true)),
                new DropdownInputField("HubId", "cab-hub-hub", "Hub", "", true, new DropdownInputOptions("pl-short-hub", false, true, true, true)),
                new DropdownInputField("StatusId", "cab-hub-connection-form-status", "Status", "", true, new DropdownInputOptions("pl-connection-status", false, true, false)),
                new DateInputField("StartDate", "cab-hub-start-date", "Start Date", "", true, new DateInputOptions()),
                new DateInputField("EndDate", "cab-hub-end-date", "End Date", "", false, new DateInputOptions()),
                new FileUploadInputField("AgreementUploadId", "cab-hub-agreement-upload", "Agreement / Contract Upload", "", false, new FileUploadInputOptions("cab-hub-uploads", false, true)),
                new TextInputField("AdminNotes", "cab-hub-notes", "Notes", "Add internal notes about the relationship, status, documentation, or follow-up items.", false, textOptions)
            ]
        });

        let formSections = [section];

        return formSections;
    }

    static getNotesCheckInFormSections(): FormSection[] {
        let textOptions = new TextInputOptions(TextInputType.Any, -99, -99, false, 4);

        let section: FormSection = new FormSection({
            sectionId: "cab-hub-check-in-form",
            displayName: "",
            formFields: [
                new TextInputField("AdminNotes", "connection-cab-hub-notes", "Notes", "Add internal notes about the relationship, status, documentation, or follow-up items.", false, textOptions),
                new DateInputField("OneMonthCheckInDate", "connection-cab-hub-one-month-date", "One Month Check In Date", "", false, new DateInputOptions()),
                new TextInputField("OneMonthCheckInNotes", "connection-cab-hub-one-month-notes", "One Month Check In Notes", "", false, textOptions),
                new DateInputField("SixMonthCheckInDate", "connection-cab-hub-six-month-date", "Six Month Check In Date", "", false, new DateInputOptions()),
                new TextInputField("SixMonthCheckInNotes", "connection-cab-hub-six-month-notes", "Six Month Check In Notes", "", false, textOptions),
            ]
        });

        let formSections = [section];

        return formSections;
    }
}